import { Map as IMap } from 'immutable';

export const getCompletedSteps = state => state.get('completedSteps', IMap());
